import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Onboarding } from '../../../models/onboarding';
import { ApiService } from '../../../services/api.service';
import { Product } from '../../../models/product';
import { Cooperative } from './../../../models/cooperatives';

@Component({
  selector: 'alg-payment-radio',
  templateUrl: './alg-payment-radio.component.html',
  styleUrls: ['./alg-payment-radio.component.scss']
})
export class AlgPaymentRadioComponent implements OnInit {
  @Input() default: string;
  @Input() isSocio = false;
  @Input() currentCooperative = -1;
  @Input() currentCooperativeObject: Cooperative;
  @Input() codeCard = '';
  @Output() select = new EventEmitter<any>();
  public currentIndex = 1;
  public cardSelectedIndex: number;
  public typePayment: string;
  public currentOnboarding: Onboarding = {} as Onboarding;
  public currentProduct: Product = {} as Product;

  constructor(private api: ApiService) { }

  ngOnInit() {
    this.api.currentOnboarding.subscribe((onboarding: Onboarding) => {
      this.currentOnboarding = onboarding;
      this.default = this.currentOnboarding.paymentType;
    });
    this.api.currentProduct.subscribe((product: Product) => {
      this.currentProduct = product;
      if (product && !!product.family) {
        if (product.family.ridDisabled && !product.family.bollettinoDisabled) {
          this.selectedItem(0)
        } else if (!product.family.ridDisabled && product.family.bollettinoDisabled) {
          this.selectedItem(1)
        }
      }
    });
  }

  selectedItem(index) {
    this.cardSelectedIndex = index;
    if (index === 0) {
      this.typePayment = 'Bollettino';
    } else if (index === 1) {
      this.typePayment = 'Rid';
    } else {
      this.typePayment = 'Libretto';
    }
    this.select.emit(this.typePayment);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-payment-radio/alg-payment-radio.component.ts